import styled from "styled-components";

interface StyleProps {
  isCorrect?: string;
  grey?: boolean;
}

export const ErrorBox = styled.div.attrs({
  className: "font-medium",
})<StyleProps>`
  display: grid;

  grid-template-columns: 1fr 1fr;
  font-size: 11px;
  @media screen and (max-width: 768px) {
    display: block;
  }
`;

export const ErrorItem = styled.div.attrs({
  className: "mb-2",
})<StyleProps>`
  --color: ${(props) => (props.grey ? "#BFBFBF" : "#FF0000")};
  color: ${(props) => (props.isCorrect ? "#4ECF64" : "var(--color)")};
`;
// light grey: #69606C
// lighter grey: #BFBFBF
